import $ from "jquery";
import localeEn from '@/app/inventory-management/locales/en'
import localeAr from '@/app/inventory-management/locales/ar'
localStorage.getItem('NG_TRANSLATE_LANG_KEY') === 'en' ?
    import('@/app/inventory-management/theme/inventory-management.scss') :
    import('@/app/inventory-management/theme/inventory-management-rtl.scss');

import { EventBus } from "@/app/shared/services/event-bus.js";
import Loader from "@/app/shared/layouts/components/loader/loader.vue";
// import config from '@/app/inventory-management/shared/config/inventory-management-config.json';
import { noRecordTemplate, getTooltipTilte, showPopupNotification } from "@/app/shared/grid-functionality/grid-functionality.js"
export default {
  name: "error-report-RSD",
  props: [],
  data() {
    return {
      isLoading: false,
    
      suffix: "errorList",
    };
  },
  methods: {
    getTooltipTilte: (e) => getTooltipTilte(e),
    noRecordTemplate,
    showPopupNotification,
    onDataBound() {
        $('.k-filtercell [data-role="autocomplete"]').attr('placeholder', '');
    },
    //on popup opened
    modalOpenedEv() {},
    //on popup hidden
    onModalHidden() {},
    //common reset functionality
    closeModal() {
        this.$bvModal.hide("error-report-RSD");
    },
  },
  created() {},
  mounted() {
    EventBus.$on("confirmed-action", () => {
        this.$bvModal.hide("error-report-RSD");
    });
  },
  components: {
    Loader,
  },
  beforeDestroy() {
    $("body").off("click");
    EventBus.$off("confirmed-action"); 
  },
  i18n: {
    messages: {
      en: {
        ...localeEn,
      },
      ar: {
        ...localeAr,
      },
    },
  },
  computed: {
    errorsReportDS() {
        return {
            schema: {
                model: {
                    fields: {
                      rsdReasonCode: { type: "string" },
                      productBarCode: { type: "string" },
                        rsdReasonName: { type: "string" }, 
                    },
                },
            },
            data: this.listOfErrors,
        };
    },
    listOfErrors() {   
      console.log(this.$store.getters.listOfErrors);
        return this.$store.getters.listOfErrors;
    }
  },
};